(() => {
  const formatMoney = (cents, currency) => new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
  const discountedUnitPrice = (unit, discount) => unit - Math.floor(unit * discount / 100);
  document.querySelectorAll('[data-paw-product]').forEach((root) => {
    const currency = root.dataset.currency || 'USD';
    const form = root.querySelector('[data-paw-product-form]');
    const variantInput = root.querySelector('[data-paw-variant]');
    const variantPicker = root.querySelector('[data-paw-variant-picker]');
    const variantHeading = root.querySelector('[data-paw-variant-heading]');
    const packVariantInputs = [...root.querySelectorAll('[data-paw-pack-variant]')];
    const variantSlots = [...root.querySelectorAll('[data-paw-variant-slot]')];
    const tiers = [...root.querySelectorAll('.paw-pdp-tier')];
    const gift = root.querySelector('[data-paw-gift]');
    const giftVariant = root.querySelector('[data-paw-gift-variant]');
    const status = root.querySelector('[data-paw-status]');
    const submit = root.querySelector('.paw-pdp-submit');
    const thumbnailStrip = root.querySelector('.paw-pdp-gallery__thumbs');
    const galleryArrows = [...root.querySelectorAll('[data-gallery-step]')];
    let revealFrame;
    let revealSettleTimer;
    const revealThumbnail = (thumbnail, animate = true) => {
      if (!thumbnailStrip || !thumbnail) return;
      const stripRect = thumbnailStrip.getBoundingClientRect();
      const thumbnailRect = thumbnail.getBoundingClientRect();
      const edgeGap = 4;
      let delta = 0;

      if (thumbnailRect.left < stripRect.left + edgeGap) {
        delta = thumbnailRect.left - stripRect.left - edgeGap;
      } else if (thumbnailRect.right > stripRect.right - edgeGap) {
        delta = thumbnailRect.right - stripRect.right + edgeGap;
      }

      if (Math.abs(delta) < 1) return;
      const maxLeft = Math.max(0, thumbnailStrip.scrollWidth - thumbnailStrip.clientWidth);
      thumbnailStrip.scrollTo({
        left: Math.min(maxLeft, Math.max(0, thumbnailStrip.scrollLeft + delta)),
        behavior: animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
      });
    };
    const keepThumbnailVisible = (thumbnail) => {
      if (!thumbnail) return;
      window.cancelAnimationFrame(revealFrame);
      window.clearTimeout(revealSettleTimer);
      revealFrame = window.requestAnimationFrame(() => {
        revealThumbnail(thumbnail);
        revealSettleTimer = window.setTimeout(() => {
          if (thumbnail.classList.contains('is-active')) revealThumbnail(thumbnail, false);
        }, 350);
      });
    };
    const activateMedia = (mediaId) => {
      if (!mediaId) return;
      const target = String(mediaId);
      root.querySelectorAll('.paw-pdp-gallery__slide').forEach((slide) => slide.classList.toggle('is-active', slide.dataset.mediaId === target));
      let activeThumbnail;
      root.querySelectorAll('[data-media-target]').forEach((thumb) => {
        const isActive = thumb.dataset.mediaTarget === target;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) activeThumbnail = thumb;
      });
      keepThumbnailVisible(activeThumbnail);
    };
    const activateAdjacentMedia = (step) => {
      const thumbnails = [...root.querySelectorAll('.paw-pdp-gallery__thumb[data-media-target]')];
      if (!thumbnails.length) return;
      const activeIndex = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));
      const nextIndex = (activeIndex + step + thumbnails.length) % thumbnails.length;
      activateMedia(thumbnails[nextIndex].dataset.mediaTarget);
    };
    const getSelectedOption = (input) => input?.tagName === 'SELECT' ? input.selectedOptions[0] : input;
    const getInputPrice = (input) => Number(getSelectedOption(input)?.dataset.price || 0);
    const getInputComparePrice = (input) => Number(getSelectedOption(input)?.dataset.comparePrice || 0);
    const getPackInputs = (quantity) => packVariantInputs.length
      ? packVariantInputs.slice(0, quantity)
      : Array.from({ length: quantity }, () => variantInput);
    const getPackPrice = (quantity, discount, discountAmount = 0) => {
      const prices = getPackInputs(quantity).map((input) => getInputPrice(input));
      const regularTotal = prices.reduce((total, price) => total + price, 0);
      if (quantity === 3 && discountAmount > 0) {
        return prices.reduce((total, price) => total + Math.max(0, price - discountAmount), 0) + Number(giftVariant?.dataset.price || 0);
      }
      if (quantity === 3) return regularTotal - Math.floor(regularTotal * discount / 100);
      return prices.reduce((total, price) => total + discountedUnitPrice(price, discount), 0);
    };
    const updateVariantPicker = (quantity) => {
      if (!variantPicker) return;
      const isMulti = quantity > 1;
      variantPicker.classList.toggle('is-multi', isMulti);
      variantHeading.textContent = isMulti ? variantPicker.dataset.multipleHeading : variantPicker.dataset.singleHeading;
      variantSlots.forEach((slot, index) => { slot.hidden = index >= quantity; });
    };
    const update = () => {
      const selected = root.querySelector('input[name="quantity"]:checked');
      const quantity = Number(selected.value);
      const discount = Number(selected.dataset.discount || 0);
      const discountAmount = Number(selected.dataset.discountAmount || 0);
      const unit = getInputPrice(variantInput);
      const compare = getInputComparePrice(variantInput);
      const regularUnit = compare > unit ? compare : Math.round(unit * 10 / 7);
      const total = getPackPrice(quantity, discount, discountAmount);
      tiers.forEach((tier) => tier.classList.toggle('is-selected', tier.contains(selected)));
      updateVariantPicker(quantity);
      const giftEnabled = Boolean(giftVariant?.value);
      gift?.classList.toggle('is-visible', quantity === 3 && giftEnabled);
      root.querySelector('[data-paw-submit-label]').textContent = `Add ${quantity} to cart`;
      root.querySelector('[data-paw-submit-price]').textContent = formatMoney(total, currency);
      const unitPrice = root.querySelector('[data-unit-price]');
      const unitRegular = root.querySelector('[data-unit-regular]');
      unitPrice.textContent = formatMoney(unit, currency);
      unitRegular.textContent = formatMoney(regularUnit, currency);
      unitPrice.parentElement.setAttribute('aria-label', `Sale price ${formatMoney(unit, currency)}; regular price ${formatMoney(regularUnit, currency)}`);
      root.querySelectorAll('[data-tier-price]').forEach((node) => {
        const qty = Number(node.dataset.tierPrice);
        const radio = root.querySelector(`input[name="quantity"][value="${qty}"]`);
        const off = Number(radio?.dataset.discount || 0);
        const amount = Number(radio?.dataset.discountAmount || 0);
        node.textContent = formatMoney(getPackPrice(qty, off, amount), currency);
      });
      root.querySelectorAll('[data-tier-regular]').forEach((node) => {
        const qty = Number(node.dataset.tierRegular);
        const productRegular = getPackInputs(qty).reduce((totalPrice, input) => totalPrice + getInputPrice(input), 0);
        const regular = qty === 1 ? regularUnit : productRegular + (qty === 3 ? Number(giftVariant?.dataset.price || 0) : 0);
        node.textContent = formatMoney(regular, currency);
      });
    };
    root.querySelectorAll('input[name="quantity"]').forEach((radio) => radio.addEventListener('change', update));
    if (packVariantInputs.length) {
      packVariantInputs.forEach((input, index) => input.addEventListener('change', () => {
        if (index === 0) {
          packVariantInputs.slice(1).forEach((additionalInput) => {
            if (additionalInput.dataset.userChanged !== 'true') additionalInput.value = input.value;
          });
        } else {
          input.dataset.userChanged = 'true';
        }
        update();
        activateMedia(input.selectedOptions[0]?.dataset.mediaId);
      }));
    } else {
      variantInput.addEventListener('change', update);
    }
    update();
    window.addEventListener('resize', () => {
      keepThumbnailVisible(root.querySelector('.paw-pdp-gallery__thumb.is-active'));
    });
    galleryArrows.forEach((button) => button.addEventListener('click', () => activateAdjacentMedia(Number(button.dataset.galleryStep))));
    root.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => activateMedia(button.dataset.mediaTarget)));
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const quantity = Number(root.querySelector('input[name="quantity"]:checked').value);
      const variantQuantities = getPackInputs(quantity).reduce((quantities, input) => {
        const variantId = Number(input.value);
        quantities.set(variantId, (quantities.get(variantId) || 0) + 1);
        return quantities;
      }, new Map());
      const items = [...variantQuantities].map(([id, itemQuantity]) => ({ id, quantity: itemQuantity }));
      if (quantity === 3 && giftVariant?.value) items.push({ id: Number(giftVariant.value), quantity: 1, properties: { 'Included with': '3-item pack' } });
      submit.disabled = true;
      status.textContent = 'Adding your pack…';
      if (root.dataset.preview === 'true') {
        window.setTimeout(() => { status.textContent = 'Preview only — Shopify will add this pack to cart.'; submit.disabled = false; }, 350);
        return;
      }
      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error('Cart request failed');
        window.location.href = `${rootPath}cart`;
      } catch (error) {
        status.textContent = 'We could not add that pack. Please refresh and try again.';
        submit.disabled = false;
      }
    });
  });
})();
